<div class="modal-body">
	<div class="orderhistory-modal__content w-100">
		<div class="orderhistory-modal__header">
			<span># {{ order.order_number }}</span>
			<a href="javascript:void()" data-dismiss="modal" (click)="activeModal.dismiss()">
				<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L8.41421 7L13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071C13.3166 14.0976 12.6834 14.0976 12.2929 13.7071L7 8.41421L1.70711 13.7071C1.31658 14.0976 0.683417 14.0976 0.292893 13.7071C-0.0976311 13.3166 -0.0976311 12.6834 0.292893 12.2929L5.58579 7L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z" fill="#0D0D0D"/>
				</svg>
			</a>
		</div>
		
		<ng-container *ngIf="order.delivery_with == 'oto'; else noOtoOrder">
			<div class="orderstatus-history__steps">
				<div class="orderstatus-history__longStepDivider"><span></span></div>
				<div class="orderstatus-history-step" *ngFor="let status of order.oto_history.history; let i=index; let first=first; let last=last" [ngClass]="{'orderstatus-history-step--active':last}">
					<div class="orderstatus-history-step__icon">
					</div>
					<div class="orderstatus-history-step__info">
						<div class="orderstatus-history-step__infoText w-50">
							<h1 class="orderstatus-history-step__title" >{{ status.date | date : 'mediumDate' }}</h1>
							<h1 class="orderstatus-history-step__title" >{{ status.date | timezone: 'GMT': 'Asia/Riyadh' | date : 'shortTime'  }}</h1>
						</div>
						<div class="orderstatus-history-step__infoStatus">
							<span class="catalogue-table__status p-1" [ngClass]="{
								'catalogue-table__status--new' : status.status == 'new',
								'catalogue-table__status--preparing' : status.status == 'preparing',
								'catalogue-table__status--readytopickup' : status.status == 'ready_to_pickup',
								'catalogue-table__status--pending' : status.status == 'pending',
								'catalogue-table__status--canceled' : (status.status == 'canceled' || status.status == 'rejected'),
								'catalogue-table__status--refunded' : status.status == 'refunded',
								'catalogue-table__status--outfordelivery' : status.status == 'out_for_delivery',
								'catalogue-table__status--completed' : status.status == 'completed'
								}"></span>
							<span>{{ status.status | titlecase | removeUnderscore }}</span>
							<span *ngIf="status?.description"> ({{ status?.description }})</span>
						</div>
					</div>
				</div>
			</div>
		</ng-container>

		<ng-template #noOtoOrder>
			<div class="orderstatus-history__steps">
				<div class="orderstatus-history__longStepDivider"><span></span></div>
				<div class="orderstatus-history-step">
					<div class="orderstatus-history-step__icon">
					</div>
					<div class="orderstatus-history-step__info">
						<div class="orderstatus-history-step__infoText">
							<h1 class="orderstatus-history-step__title" >{{ order.created_at | date : 'mediumDate' }}</h1>
							<h1 class="orderstatus-history-step__title" >{{ order.created_at | date : 'shortTime' }}</h1>
						</div>
						<div class="orderstatus-history-step__infoStatus">
							<span class="catalogue-table__status catalogue-table__status--new"></span>
							<span i18n="@@orders.new">New</span>
						</div>
					</div>
				</div>
				<div class="orderstatus-history-step" *ngFor="let status of order.statuses; let i=index; let first=first; let last=last" [ngClass]="{'orderstatus-history-step--active':last}">
					<div class="orderstatus-history-step__icon">
					</div>
					<div class="orderstatus-history-step__info">
						<div class="orderstatus-history-step__infoText">
							<h1 class="orderstatus-history-step__title" >{{ status.created_at | date : 'mediumDate' }}</h1>
							<h1 class="orderstatus-history-step__title" >{{ status.created_at | date : 'shortTime' }}</h1>
						</div>
						<div class="orderstatus-history-step__infoStatus">
							<span class="catalogue-table__status" [ngClass]="{
								'catalogue-table__status--new' : status.status == 'new',
								'catalogue-table__status--preparing' : status.status == 'preparing',
								'catalogue-table__status--readytopickup' : status.status == 'ready_to_pickup',
								'catalogue-table__status--pending' : status.status == 'pending',
								'catalogue-table__status--canceled' : (status.status == 'canceled' || status.status == 'rejected'),
								'catalogue-table__status--refunded' : status.status == 'refunded',
								'catalogue-table__status--outfordelivery' : status.status == 'out_for_delivery',
								'catalogue-table__status--completed' : status.status == 'completed'
								}"></span>
							<span>{{ status.status | titlecase | removeUnderscore }}</span>
						</div>
					</div>
				</div>
			</div>
		</ng-template>
		

	</div>
</div>